import getSymbolFromCurrency from 'currency-symbol-map'

export const currencySymbol = (currency: string) => {
    return getSymbolFromCurrency(currency ? currency.toUpperCase() : "EUR");
}

export const priceToDisplay = (amount: number | null, currency: string) => {
    return `${((amount ? amount : 0) / 100).toFixed(2)} ${currencySymbol(currency)}`
}
